import { setContext, getContext } from 'svelte';
import { writable } from 'svelte/store';
export function setTheme(theme) {
    const themeStore = writable(theme);
    setContext('twist-theme', themeStore);
    return themeStore;
}
export function useTwistTheme() {
    const themeStore = getContext('twist-theme');
    if (!themeStore) {
        throw new Error('No Twist Theme found; Make sure wrap your app with `TwistThemeProvider`');
    }
    return themeStore;
}
export function useTwistThemeSafe() {
    return getContext('twist-theme');
}
